<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-gears"></i
                ><strong>
                  Ingreso de procesos
                  <span v-if="processData.number"
                    >#{{ processData.number }}</span
                  >
                </strong>
                <div class="card-header-actions">
                  <b-select
                    :disabled="!canEditSala"
                    size="sm"
                    v-model="selectedSala"
                    :options="salas"
                    @change="handleSalaChange($event)"
                  ></b-select>
                </div>
              </div>
              <form-wizard
                color="#20a8d8"
                errorColor="#f86c6b"
                shape="circle"
                stepSize="xs"
                next-button-text="Siguiente"
                back-button-text="Atras"
                finish-button-text="Terminar"
                ref="wizard"
                title=""
                subtitle=""
              >
                <tab-content
                  class="animated fadeIn"
                  title="Proceso"
                  :before-change="validateForm2"
                >
                  <proceso-form-2
                    :processData="processData"
                    :shifts="plantsInfo.shifts"
                    :process_types="plantsInfo.process_types"
                    :supervisors="plantsInfo.workers"
                    :plants="plantsInfo.plants"
                    :selectedSala="selectedSala"
                    @validate="formStepVal2 = $event"
                    ref="processform2"
                  ></proceso-form-2>
                </tab-content>

                <tab-content
                  class="animated fadeIn"
                  title="Información del proceso"
                  :before-change="validateForm1"
                >
                  <proceso-form
                    :processData="processData"
                    :disabledform="disabledform"
                    :products="products"
                    @validate="formStepVal1 = $event"
                    @origins="origins = $event"
                    ref="processform1"
                  >
                  </proceso-form>
                </tab-content>

                <tab-content
                  class="animated fadeIn"
                  title="Selección de pallets a proceso"
                  :before-change="validatePalletProcesoForm"
                >
                  <informacion-proceso
                    :sumMarkedKilograms="sumMarkedKilograms"
                    :sumNetKilograms="sumNetKilograms"
                    :processNumber="processData.number"
                    :kilogramDiference="kilogramDiference"
                    :kilogramExportacion="kilogramExportacion"
                    :kilogramMerma="kilogramMerma"
                    :wastePercentage="wastePercentage"
                    :exportPercentage="exportPercentage"
                  >
                  </informacion-proceso>
                  <stock
                    ref="StockTable"
                    :is="stock"
                    :kilogramDiference="kilogramDiference"
                    :kilogramExportacion="kilogramExportacion"
                    :kilogramMerma="kilogramMerma"
                    :stockUrl="stockUrl"
                    :supervisors="plantsInfo.workers"
                    :processData="processData"
                    @sumMarkedKilograms="sumMarkedKilograms = $event"
                  >
                  </stock>
                </tab-content>
                <tab-content
                  class="animated fadeIn"
                  title="Ingrese los resultados del proceso"
                  :before-change="EndProcess"
                >
                  <informacion-proceso
                    :sumMarkedKilograms="sumMarkedKilograms"
                    :sumNetKilograms="sumNetKilograms"
                    :processNumber="processData.number"
                    :kilogramDiference="kilogramDiference"
                    :kilogramExportacion="kilogramExportacion"
                    :kilogramMerma="kilogramMerma"
                    :wastePercentage="wastePercentage"
                    :exportPercentage="exportPercentage"
                  >
                  </informacion-proceso>
                  <create-content
                    :data="processData"
                    :products="products"
                    :origins="origins"
                    :plants="plantsInfo.plants"
                    :disabledFields="disabledFields"
                    :sumMarkedKilograms="sumMarkedKilograms"
                    :sumNetKilograms="sumNetKilograms"
                    :kilogramDiference="kilogramDiference"
                    :kilogramExportacion="kilogramExportacion"
                    :kilogramMerma="kilogramMerma"
                    @refresh="getProducedData($event)"
                    @loadSupplyDetails="loadSupplyDetails"
                  >
                  </create-content>
                  <processed
                    ref="ProcessedTable"
                    :data="producedData"
                    :processId="processData.id"
                    @sumNetKilograms="sumNetKilograms = $event"
                    @refresh="getProducedData($event)"
                    :tableType="tableType"
                  >
                  </processed>

                  <h3>Materiales</h3>
                  <DetailedSupplyTable
                    :sypplyItems="sypplyItems"
                    :sypplyFields="sypplyFields"
                    :processId="processData.id"
                    :client_customer="processData.client_customer"
                    @loadSupplyDetails="loadSupplyDetails"
                    small
                  >
                  </DetailedSupplyTable>
                </tab-content>
                <tab-content
                  title="Revisión del proceso"
                  :before-change="tapTerminar"
                >
                  <report ref="report" :process="process"></report>
                  <!-- <component :is="report" ref="report"></component> -->
                </tab-content>
              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>

      <!-- Modal terminar Proceso-->
      <b-modal
        id="ModalTerminarProceso"
        title="Terminar proceso"
        size="md"
        class="modal-primary"
        v-model="modalShown"
        hide-footer
      >
        <b-form @submit.prevent="onSubmitTerminarProceso">
          <b-form-group>
            <template v-if="editProcess == false">
              <label> Ingrese fecha fin de proceso </label>

              <datetime
                type="datetime"
                :state="
                  $v.inputFechaTermino.$dirty
                    ? !$v.inputFechaTermino.$error
                    : null
                "
                v-model="$v.inputFechaTermino.$model"
                required
                :minute-step="10"
                aria-describedby="input-inputFechaTermino-live-feedback"
                input-class="form-control"
                class="theme-orange"
              >
              </datetime>

              <b-form-invalid-feedback
                id="input-inputFechaTermino-live-feedback"
              >
                Fecha es requerido
              </b-form-invalid-feedback>
            </template>

            <template v-if="editProcess == true"> </template>
          </b-form-group>

          <b-form-group>
            <label> Comentario del proceso <span class="text-danger">*</span></label>
            <b-form-textarea
              v-model="$v.inputComentarioProceso.$model"
              :state="
                $v.inputComentarioProceso.$dirty
                  ? !$v.inputComentarioProceso.$error
                  : null
              "
              rows="4"
              placeholder="Ingrese un comentario sobre el proceso..."
              aria-describedby="input-inputComentarioProceso-live-feedback"
            >
            </b-form-textarea>
            <b-form-invalid-feedback
              id="input-inputComentarioProceso-live-feedback"
            >
              El comentario es requerido
            </b-form-invalid-feedback>
          </b-form-group>

          <b-button type="submit" variant="primary">Terminar</b-button>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Stock from "./StockTable";
import Processed from "./ProcessedTable";
import ProcesoForm from "./ProcesoForm";
import ProcesoForm2 from "./ProcesoForm2";
import InformacionProceso from "./InformacionProceso";
import Report from "./Report2";
import CreateContent from "./CreateContent";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import DetailedSupplyTable from "./DetailedSupplyTable.vue";

import {
  required,
  numeric,
  minLength,
  between
} from "vuelidate/lib/validators";

import Vue from "vue";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

numeral.locale("es");

var d = new Date();

export default {
  name: "inicio",
  components: {
    FormWizard,
    TabContent,
    Stock,
    Processed,
    CreateContent,
    ProcesoForm,
    ProcesoForm2,
    Report,
    InformacionProceso,
    DetailedSupplyTable
  },
  props: ["typeProcess", "processID"],
  mounted() {
    //this.getProducts();
    this.getPlantsInfo();

    if (this.processID != null) {
      this.loadProcess(this.processID);
      this.editProcess = true;
    } else {
      this.editProcess = false;
    }
    const sala = localStorage.getItem("sala");
    if (sala) {
      this.selectedSala = sala;
    }
    if (
      this.$store.state.user.ID_USUARIO === 1 ||
      this.$store.state.user.ID_USUARIO === 102
    ) {
      this.canEditSala = true;
    }
    console.log(this.$store.state.user.ID_USUARIO);
  },
  data() {
    return {
      process: null,
      report: "",
      disabledform: false,
      modalShown: false,
      stock: "",
      title: "",
      tableType: 2,
      sumMarkedKilograms: numeral(0),
      sumNetKilograms: numeral(0),
      kilogramExportacion: 0,
      kilogramMerma: 0,
      editProcess: false,
      disabledFields: {
        product: true,
        variety: true,
        condition: true,
        origin: true,
        plant: true
      },
      processData: {
        id: null,
        number: null,
        start_time: null,
        end_time: null,
        process_type: null,
        shift: null,
        shift_workers: null,
        shift_supervisor: null,
        note: null,
        material_waybill: null,
        plant: null,
        origin: null,
        process_room: null,
        variety: "",
        product: null,
        condition: "",
        company: "",
        client_customer: "null",
        contents_in: []
      },
      canEditSala: false,
      formStepVal1: false,
      formStepVal2: false,
      producedData: [],
      inputFechaTermino: "",
      inputComentarioProceso: "",

      // Select options
      products: [],
      plantsInfo: {
        shifts: [{ value: null, text: "Cargando..." }],
        process_types: [{ value: null, text: "Cargando..." }],
        supervisors: [{ value: null, text: "Cargando..." }],
        plants: [{ value: null, text: "Cargando..." }]
      },
      origins: [],
      sypplyItems: [],
      sypplyFields: [
        { key: "supply.code", label: "Código" },
        { key: "supply.name", label: "Material" },
        { key: "quantity", label: "Cantidad" },
        { key: "supply.unit", label: "Unidad" },
        { key: "supply_lot", label: "Lote material" },
        { key: "actions", label: " " }
      ],
      salas: [
        { value: null, text: "Todas" },
        { value: "SP1", text: "SP1" },
        { value: "SP2", text: "SP2" },
        { value: "SP3", text: "SP3" },
        { value: "SP1 - L3", text: "SP1 - L3" },
        { value: "SP1 - L4", text: "SP1 - L4" },
        { value: "SP2 - L1", text: "SP2 - L1" },
        { value: "SP2 - L2", text: "SP2 - L2" },
        { value: "SP3 - L5", text: "SP3 - L5" }
      ],
      selectedSala: null
    };
  },
  watch: {
    producedData: {
      handler(val) {
        if (this.producedData.length > 0) {
          this.disabledform = true;
        } else {
          this.disabledform = false;
        }
      }
    }
  },
  computed: {
    kilogramDiference() {
      return numeral(
        this.sumMarkedKilograms.value() - this.sumNetKilograms.value()
      );
    },
    stockUrl() {
      const url =
        "/api/v1/stockprocess/?" +
        "variety__product=" +
        this.processData.product +
        "&origin=" +
        this.processData.origin +
        "&condition=" +
        this.processData.condition +
        "&variety=" +
        this.processData.variety +
        "&process_id=" +
        this.processData.id +
        "&process_edit=" +
        this.editProcess +
        "&client_customer=" +
        this.processData.client_customer;
      return url;
    },
    wastePercentage() {
      let value = this.producedData.reduce(
        (acc, item) => acc + item.net_kilograms.value() * item.waste,
        0
      );
      value = (value / this.sumMarkedKilograms.value()) * 100;
      return parseFloat(value).toFixed(2) + " %";
    },
    exportPercentage() {
      let value = this.producedData.reduce(
        (acc, item) => acc + item.net_kilograms.value() * item.exportable,
        0
      );
      value = (value / this.sumMarkedKilograms.value()) * 100;
      return parseFloat(value).toFixed(2) + " %";
    }
  },
  validations: {
    inputFechaTermino: {
      required
    },
    inputComentarioProceso: {
      required
    }
  },
  methods: {
    handleSalaChange(ev) {
      console.log(ev);
      localStorage.setItem("sala", ev);
      this.selectedSala = ev;
    },
    loadSupplyDetails() {
      if (this.processData.id != undefined && this.processData.id != null) {
        this.$axios
          .get(
            "api/supplies/waybill/" +
              this.processData.id +
              "/waybill_detail_process/"
          )
          .then((res) => {
            this.sypplyItems = res.data;
          })
          .catch((error) => console.log(error));
      }
    },
    getProcess(process_id) {
      this.$axios
        .get("/api/v1/process/" + process_id + "/detailed_with_traceability/")
        // .then(x => new Promise(resolve => setTimeout(() => resolve(x), 2000)))
        .then((res) => {
          this.process = res.data;
        })
        .catch((error) => console.log(error));
    },
    loadProcess(process_id) {
      this.$axios
        .get("/api/v1/process/" + process_id + "/detailed_with_traceability/")
        .then((res) => {
          this.processData.id = res.data.id;
          this.processData.number = res.data.number;
          this.processData.plant = {
            id: res.data.process_room.plant.id,
            name: res.data.process_room.plant.name,
            plant_code: res.data.process_room.plant.plant_code,
            company: res.data.process_room.plant.company.id
          };
          this.$refs.processform2.getProcessRooms(
            res.data.process_room.plant.id
          );
          this.processData.process_room = res.data.process_room.id;
          this.processData.shift = res.data.shift.id;
          this.processData.shift_supervisor = res.data.shift_supervisor.id;
          this.processData.shift_workers = res.data.shift_workers;
          this.processData.start_time = res.data.start_time;
          this.processData.end_time = res.data.end_time;
          this.processData.process_type = res.data.process_type.id;
          this.processData.note = res.data.note;
          this.processData.material_waybill = res.data.material_waybill;
          this.processData.client_customer = res.data.client_customer.id;
          this.$refs.processform1.getCompanies(
            this.processData.client_customer
          );
          this.processData.company = res.data.company;
          this.$refs.processform1.getCompanyFacilities(
            this.processData.company
          );
          this.processData.origin = res.data.origin;
          this.processData.product = res.data.product;
          this.$refs.processform1.getProductSet(this.processData.product);
          this.processData.variety = res.data.variety;
          this.processData.condition = res.data.condition;
          this.stock = "stock";
          // this.getProducedData(res.data.id);

          const c_in = res.data.contents_in;
          const items_in = [];
          for (let key in c_in) {
            const item = c_in[key];
            c_in[key].waybill_date = moment(c_in[key].waybill_date).format(
              "DD-MM-YYYY"
            );
            c_in[key].net_kilograms = numeral(
              parseFloat(c_in[key].net_kilograms)
            );
            items_in.push(item);
          }
          this.processData.contents_in = items_in;

          const c_out = res.data.contents_out;
          const items_out = [];
          for (let key in c_out) {
            const item = c_out[key];
            c_out[key].waybill_date = moment(c_out[key].waybill_date).format(
              "DD-MM-YYYY"
            );
            c_out[key].net_kilograms = numeral(
              parseFloat(c_out[key].net_kilograms)
            );
            items_out.push(item);
          }

          this.producedData = items_out;

          // $refs is undefined in mounted() --> use $nextTick
          // https://stackoverflow.com/questions/40884194/vuejs-cant-access-refs-from-component
          this.$nextTick(function () {
            this.$refs.StockTable.markedRows = this.processData.contents_in;
          });
        })
        .catch((error) => console.log(error));
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          this.products = res.data.data;
        })
        .catch((error) => console.log(errors));
    },
    getPlantsInfo() {
      this.$axios
        .get("/production/get_client_plants/")
        .then((res) => {
          this.plantsInfo = res.data;
        })
        .catch((error) => console.log(errors));
    },
    validateForm1() {
      this.$refs.processform1.submit();

      if (this.formStepVal1 === true) {
        this.loadSupplyDetails();
        if (this.processData.number === null) {
          this.submitProcess();
          this.stock = "stock";
        } else {
          this.updateProcess(this.processData.id);
        }
        return true;
      } else {
        this.$swal.fire(
          "Campos requeridos o invalidos en el formulario",
          "",
          "warning"
        );

        return false;
      }
    },
    validateForm2() {
      this.$refs.processform2.submit();
      if (this.formStepVal2 === true) {
        return true;
      } else {
        this.$swal.fire(
          "Campos requeridos o invalidos en el formulario",
          "",
          "warning"
        );

        return false;
      }
    },
    getProducedData(process) {
      const url = "/api/v1/process/" + process + "/content_list/";
      this.$axios
        .get(url)
        .then((res) => {
          const data = res.data;
          const items = [];

          this.kilogramExportacion = 0;
          this.kilogramMerma = 0;

          for (let key in data) {
            const item = data[key];

            let net_kilograms_aux = data[key].net_kilograms;

            data[key].waybill_date = moment(data[key].waybill_date).format(
              "DD-MM-YYYY"
            );
            data[key].net_kilograms = numeral(
              parseFloat(data[key].net_kilograms)
            );

            if (data[key].exportable == true) {
              this.kilogramExportacion =
                parseFloat(this.kilogramExportacion) +
                parseFloat(net_kilograms_aux);
            }

            if (data[key].waste == true) {
              this.kilogramMerma =
                parseFloat(this.kilogramMerma) + parseFloat(net_kilograms_aux);
            }

            //  this.kilogramExportacion
            //exportable: true

            items.push(item);
          }

          //this.kilogramExportacion = numeral(this.kilogramExportacion.value());
          //this.kilogramMerma =  numeral(this.kilogramMerma.value());

          this.producedData = items;
        })
        .catch((error) => console.log(error));
    },

    // Create and Update Process
    submitProcess() {
      const formData = {
        start_time: this.processData.start_time,
        end_time: this.processData.end_time,
        process_type: this.typeProcess,
        shift: this.processData.shift,
        shift_workers: this.processData.shift_workers,
        shift_supervisor: this.processData.shift_supervisor,
        note: this.processData.note,
        material_waybill: this.processData.material_waybill,
        process_room: this.processData.process_room,
        client_customer: this.processData.client_customer,
        client: this.$store.getters.user.ID_CLIENTE
      };
      this.$axios
        .post("/api/v1/process/", formData)
        .then((res) => {
          miniToastr.success("Proceso creado", "");
          this.processData.id = res.data.id;
          this.processData.number = res.data.number;
        })
        .catch(function (error) {
          miniToastr.error("Problemas al crear proceso", "");

          console.log(error.response);
        });
    },
    updateProcess(a) {
      const formData = {
        id: this.processData.id,
        start_time: this.processData.start_time,
        end_time: this.processData.end_time,
        process_type: this.typeProcess,
        shift: this.processData.shift,
        shift_workers: this.processData.shift_workers,
        shift_supervisor: this.processData.shift_supervisor,
        note: this.processData.note,
        material_waybill: this.processData.material_waybill,
        process_room: this.processData.process_room,
        client_customer: this.processData.client_customer,
        client: this.$store.getters.user.ID_CLIENTE
      };
      this.$axios
        .put("/api/v1/process/" + a + "/", formData)
        .then((res) => {
          this.processData.id = res.data.id;
          this.processData.number = res.data.number;

          miniToastr.success("Proceso actualizado", "");
        })
        .catch(function (error) {
          miniToastr.error("Problemas al actualizar proceso", "");

          console.log(error.response);
        });
    },
    validatePalletProcesoForm() {
      if (this.$refs.StockTable.validateAndTraceability() == 1) {
        return true;
      } else {
        this.$swal.fire("Seleccione por lo menos un pallet", "", "warning");

        return false;
      }
    },
    EndProcess() {
      this.modalShown = false;
      if (
        this.producedData.length > 0 &&
        Math.fround(this.kilogramDiference.value()) == Math.fround("0.00")
      ) {
        this.report = "report";
        this.getProcess(this.processData.id);
        return true;
      } else {
        this.$swal.fire(
          "Debe haber procesado por lo menos un contenido y cuadratura tiene que ser cero para poder continuar",
          "",
          "warning"
        );
        return false;
      }
    },
    onSubmitTerminarProceso() {
      // Validar solo el comentario
      this.$v.inputComentarioProceso.$touch();
      
      if (this.$v.inputComentarioProceso.$invalid) {
        this.$swal.fire(
          "El comentario del proceso es requerido",
          "",
          "warning"
        );
        return;
      }

      // Validar fecha solo si no es edición
      if (this.editProcess == false) {
        this.$v.inputFechaTermino.$touch();
        
        if (this.$v.inputFechaTermino.$invalid) {
          this.$swal.fire(
            "La fecha de término es requerida",
            "",
            "warning"
          );
          return;
        }
      }

      const formData = {
        id: this.processData.id,
        end_time: this.inputFechaTermino,
        note: this.inputComentarioProceso,
        edit_process: this.editProcess,
        client: this.$store.getters.user.ID_CLIENTE
      };

      this.$axios
        .put("/api/v1/process/finish_process/", formData)
        .then((res) => {
          this.modalShown = false;

          if (res.data.status == 1) {
            this.$swal.fire("Proceso concluido con éxito", "", "success");

            this.$router.push("/proceso/list");

            return true;
          } else {
            this.$swal.fire("Problemas al terminar proceso", "", "error");

            return false;
          }
        })
        .catch((error) => console.log(error));
    },
    tapTerminar() {
      this.modalShown = true;
    }
  },
  beforeMount() {}
};
</script>

<style>
.wizard-header {
  padding: 0px !important;
}
</style>
